import React, { useState, useEffect } from 'react';
import { authSoftwareHelper } from '../dal/authSoftwareHelper';

//軟體採購頁面
export const ProcureList = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
  const [softwareList, setSoftwareList] = useState<any[]>([]);

  useEffect(() => {
    const checkAuthAndFetch = async () => {
      try {
        const aliveResp = await fetch('/api/auth/check_alive');
        const aliveData = await aliveResp.json();
        const loggedIn = aliveData.alive === true;
        setIsLoggedIn(loggedIn);

        if (loggedIn) {
          const userInfoResp = await fetch('/api/auth/userinfo');
          const userInfo = await userInfoResp.json();

          const schoolsMap = new Map<string, { school_code: string, school_type: string }>();

          const extractSchools = (details: any[]) => {
            if (!details) return;
            details.forEach(dept => {
              const { school_code, school_type } = dept;
              if (school_code && school_type) {
                schoolsMap.set(`${school_code}_${school_type}`, { school_code, school_type });
              }
            });
          };

          extractSchools(userInfo.teacherDetail);
          extractSchools(userInfo.studentDetail);
          extractSchools(userInfo.parentDetail);
          const currSchoolCode = userInfo.userInfoOidcExt.schoolid;
          const schoolsArray = [{ school_code: currSchoolCode }];
          let allSoftware: any[] = [];
          if (schoolsArray.length > 0) {
            allSoftware = await authSoftwareHelper.getAuthSoftware(schoolsArray);
          }
          setSoftwareList(allSoftware);
        }
      } catch (e) {
        console.error(e);
        setIsLoggedIn(false);
      }
    };

    checkAuthAndFetch();
  }, []);

  return (
    <div>
      <div className="mb-20">
        <div className="flex items-center staticBanner bg-[#CFF2C6] relative">
          <div className="staticBannerContent">
            <img
              src="/images/procurementBanner.png"
              alt="banner"
              className="staticBannerImg"
            />
            <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-[47%] max-h-full overflow-auto">
              <h2 className=" font-black text-primaryDark leading-tight ">
                校園數位內容與 <br />
                教學軟體採購
              </h2>
              <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
                獲得市場上多元的數位內容和教學軟體產品，以達教材更生動及教學更多元之目標。
              </p>
            </div>
          </div>
        </div>

        {isLoggedIn === false ? (
          <div className="flex justify-center items-center h-64 text-2xl font-bold">
            請先登入
          </div>
        ) : (
          <div className="staticSection">
            <div className="sectionContent">
              <h3 className="sectionTitle text-Headline">各校授權軟體清單</h3>
              {isLoggedIn === null ? (
                <div className="text-center py-10">讀取中...</div>
              ) : softwareList.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                  {softwareList.map((sw, idx) => (
                    <div key={`${sw.id}-${idx}`} className="p-6 border rounded-xl shadow-sm bg-white hover:shadow-md transition">
                      <h4 className="text-xl font-bold text-primaryDark mb-2">{sw.product_name}</h4>
                      <p className="text-gray-700 text-sm mb-1"><span className="font-semibold">學校:</span> {sw.school_name} ({sw.school_type})</p>
                      <p className="text-gray-700 text-sm mb-1"><span className="font-semibold">序號:</span> {sw.serial_no}</p>
                      <p className="text-gray-500 text-xs mt-3 text-right">{sw.ch_year} 年度</p>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-10 text-gray-500">
                  目前沒有您的授權軟體清單
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
